import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningProfileList extends Layout {
    layoutheaderOrderPlanningProfileList: LayoutHeader;
    sourceOrderPlanningProfile: DataSource;
    tableSearch: Table;
}
